export default (apiFetch) => async (payload) => {
  const response = await apiFetch({
    endpoint: "book-valuation",
    method: "POST",
    body: payload,
    headers: {},
  });

  return await response.json();
};
